import clsx from "clsx";
import classes from "./resultNode.module.scss";
import listClasses from "../ResultList/resultList.module.scss";
import { Check } from "@educaplay/core/Icons/Check";
import { Wrong } from "@educaplay/core/Icons/Wrong";
import { ResultSideNode } from "../../ResultSideNode";

function Wrapper(props) {
  const { children, isCorrect, idx } = props;
  return (
    <div
      className={clsx(
        classes.answer,
        isCorrect ? classes.rightAnswer : classes.wrongAnswer
      )}
    >
      <div className={listClasses.leftSide}>
        <div className={classes.cardNumber}>{`${idx}`}</div>
      </div>
      <div className={classes.centerGroup}>{children}</div>

      <div className={listClasses.rightSide}>
        {isCorrect ? <Check /> : <Wrong />}
      </div>
    </div>
  );
}

export default function ResultNode({ data, idx, isCorrect }) {
  const { left, right } = data;
  return (
    <Wrapper isCorrect={isCorrect} idx={idx}>
      <ResultSideNode
        data={left}
      ></ResultSideNode>
      <div className={listClasses.middleSide}>{"-"}</div>
      <ResultSideNode
        data={right}  
      ></ResultSideNode>
    </Wrapper>
  );
}
